import { t, useT } from '@/i18n/t';

interface Props {
  current: number;
  total: number;
}

export function StepIndicator({ current, total }: Props) {
  useT();
  const defaultLabels = [t('steps.contact'), t('steps.payment'), t('steps.done')];
  const steps = Array.from({ length: total }, (_, i) => {
    const step = i + 1;
    return {
      step,
      label: defaultLabels[i] ?? t('steps.generic', { step }),
      active: step === current,
      complete: step < current,
    };
  });

  return (
    <nav class="sm-progress" aria-label={t('steps.ariaLabel', { n: current, total })}>
      <span class="sm-progress-count">{t('steps.progress', { n: current, total })}</span>
      <ol class="sm-progress-list">
        {steps.map(({ step, label, active, complete }) => (
          <li
            key={step}
            class={`sm-progress-item${active ? ' active' : ''}${complete ? ' complete' : ''}`}
            aria-current={active ? 'step' : undefined}
          >
            {label}
          </li>
        ))}
      </ol>
    </nav>
  );
}
